import { Skeleton } from '@mui/material';
import { Container } from './styled';

export const SearchProfileCardSkeleton = () => (
  <Container>
    <Skeleton variant="text" width="50%" height={34} animation="wave" />
    <Skeleton variant="rectangular" width="100%" height={38} animation="wave" sx={{ borderRadius: '4px' }} />
    <Skeleton variant="rectangular" width="30%" height={32} animation="wave" sx={{ borderRadius: '4px' }} />
    <Skeleton variant="text" width="100%" height={1} animation="wave" />
    <Skeleton variant="rectangular" width="120px" height={24} animation="wave" sx={{ borderRadius: '4px' }} />
  </Container>
);
